import { render, staticRenderFns } from "./publicLayout.vue?vue&type=template&id=3f0f8506&"
import script from "./publicLayout.vue?vue&type=script&lang=js&"
export * from "./publicLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports